import { Alert } from 'antd';

interface AudioPlayerProps {
  /** Short-lived pre-signed URL from GET /api/calls/{id}/audio-url (wired in Phase 4). */
  src?: string | null;
}

/**
 * Audio playback shell. Plays MP3/WAV from a pre-signed URL; no transcript sync in the MVP (Q13).
 * Renders a placeholder until a source is supplied.
 */
export default function AudioPlayer({ src }: AudioPlayerProps) {
  if (!src) {
    return <Alert type="info" showIcon message="فایل صوتی در دسترس نیست." />;
  }
  return (
    <audio controls preload="none" src={src} style={{ width: '100%' }}>
      مرورگر شما از پخش صوت پشتیبانی نمی‌کند.
    </audio>
  );
}
